module.exports = __webpack_public_path__ + "static/media/semiconductors_hero_mobile.50238ae5.jpg";